module.exports = __webpack_public_path__ + "img/schedule_sp.bba159f1.svg";